document.addEventListener('DOMContentLoaded', function () {
  const quiz = document.getElementById('quiz');
  if (!quiz) return;

  const METRIC = 'Color Genius Quiz';
  const PROGRESS_KEY = 'quizProgress';
  const SESSION_KEY = 'clareQuizSessionId';
  const CARD_TIMEOUT = 8000;
  let tracked = false;
  let runId = null;
  let email = '';
  let fallbackTimer = null;

  function storage(storageName, method, key, value) {
    try {
      return window[storageName][method](key, value);
    } catch (error) {
      return null;
    }
  }

  function sessionId() {
    if (runId) return runId;

    runId = storage('sessionStorage', 'getItem', SESSION_KEY);
    if (!runId) {
      runId = 'cg-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      storage('sessionStorage', 'setItem', SESSION_KEY, runId);
    }

    return runId;
  }

  function eventId() {
    return 'cg-event-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function progress() {
    const value = storage('localStorage', 'getItem', PROGRESS_KEY);
    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function steps(progressData) {
    if (progressData && progressData.steps && progressData.steps.length) return progressData.steps;
    return (window.theme && window.theme.quiz && window.theme.quiz.steps) || [];
  }

  function find(items, property, value) {
    for (let index = 0; index < items.length; index++) {
      if (items[index] && items[index][property] === value) return items[index];
    }
    return null;
  }

  function choices(step, allSteps, answers) {
    if (!step) return [];
    if (!step.isPreviousAware) return step.choices || [];
    if (step.previousAwareChoiceSet) return step.previousAwareChoiceSet;

    const previous = allSteps[allSteps.indexOf(step) - 1];
    const responses = (previous && answers[previous.id] && answers[previous.id].responses) || [];
    const groups = step.choices || [];

    for (let index = 0; index < groups.length; index++) {
      if (responses.indexOf(groups[index].key) !== -1) return groups[index].choices || [];
    }

    return [];
  }

  function choiceLabel(key, step, allSteps, answers) {
    const stepChoices = choices(step, allSteps, answers);
    const choice = find(stepChoices, 'key', key);
    return choice ? choice.text || choice.value || choice.color || key : key;
  }

  function answersSnapshot(progressData) {
    const answers = (progressData && progressData.quizAnswers) || {};
    const allSteps = steps(progressData);
    const snapshot = {};

    Object.keys(answers).forEach(function (stepId) {
      const responses = answers[stepId].responses || [];
      const labels = responses.map(function (key) {
        return choiceLabel(key, find(allSteps, 'id', stepId), allSteps, answers);
      });

      if (labels.length) snapshot[stepId] = labels.length === 1 ? labels[0] : labels;
    });

    return snapshot;
  }

  function absoluteUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url.indexOf('http') === 0 ? url : window.location.origin + url;
  }

  function productPayload(handle, fallbackTitle) {
    const products = (window.theme && window.theme.quiz && window.theme.quiz.paintProducts) || [];
    let product = null;

    for (let index = 0; index < products.length; index++) {
      if (products[index] && products[index].handle === handle) {
        product = products[index];
        break;
      }
    }

    const payload = {
      'Product Title': (product && product.title) || fallbackTitle || handle,
      'Product Handle': handle,
      'Product URL': window.location.origin + '/products/' + handle
    };

    if (product) {
      payload['Product ID'] = product.id;
      payload['Product Image URL'] = absoluteUrl(product.featured_image);
    }

    return payload;
  }

  function recommendedProducts() {
    const items = document.querySelectorAll('.results-products .grid__item');
    const handles = [];
    const products = [];

    Array.prototype.forEach.call(items, function (item) {
      const link = item.querySelector('a[href*="/products/"]');
      const match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match || handles.indexOf(match[1]) !== -1) return;

      handles.push(match[1]);
      const title = item.querySelector('.grid-product__title');
      products.push(productPayload(match[1], title ? title.textContent.trim() : ''));
    });

    return { slots: items.length, products: products };
  }

  function clearFallback() {
    if (!fallbackTimer) return;
    window.clearTimeout(fallbackTimer);
    fallbackTimer = null;
  }

  function trackQuizCompleted(allowPartial) {
    if (tracked) return;

    const results = recommendedProducts();
    if (!results.products.length || (!allowPartial && results.products.length < results.slots)) return;

    tracked = true;
    clearFallback();

    const progressData = progress();
    const payload = {
      Quiz: 'Color Genius',
      'Quiz Session ID': sessionId(),
      'Total Steps': steps(progressData).length,
      Answers: answersSnapshot(progressData),
      'Recommended Products': results.products,
      $event_id: eventId()
    };

    Object.keys(results.products[0]).forEach(function (key) {
      payload[key] = results.products[0][key];
    });

    if (email) payload.Email = email;
    (window._learnq = window._learnq || []).push(['track', METRIC, payload]);
  }

  function scheduleFallback() {
    if (fallbackTimer || tracked) return;
    fallbackTimer = window.setTimeout(function () {
      fallbackTimer = null;
      trackQuizCompleted(true);
    }, CARD_TIMEOUT);
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.classList || !form.classList.contains('signup-form')) return;

    const input = form.querySelector('.signup-form__email');
    email = input ? input.value.trim() : '';
    if (email) (window._learnq = window._learnq || []).push(['identify', { $email: email }]);
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest || !event.target.closest('.results-actions button')) return;

    tracked = false;
    runId = null;
    clearFallback();
    storage('sessionStorage', 'removeItem', SESSION_KEY);
  });

  new MutationObserver(function () {
    if (quiz.querySelector('.results-products')) {
      scheduleFallback();
      trackQuizCompleted(false);
    }
  }).observe(quiz, { childList: true, subtree: true });
});
